import React, { useCallback, useEffect, useState } from 'react';
import { Button, Empty, Space, Table, Tag, Tooltip, Typography } from 'antd';
import { ReloadOutlined, WarningOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import PageHeader from '../../../shared/components/PageHeader';
import evmAdminService from '../../../shared/services/evmAdminService';
import { adminPath } from '../../../shared/config/paths';
import { useTranslation } from '../../../shared/i18n';

const { Text } = Typography;

/** Admin: VDS core usage across nodes (GET /vds/nodes). */
const VdsNodes = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);

    const load = useCallback(async () => {
        setLoading(true);
        const r = await evmAdminService.getVdsNodes();
        setLoading(false);
        setData(r?.status === 'success' ? r.data : { available: true, nodes: [] });
    }, []);
    useEffect(() => { load(); }, [load]);

    const open = (r) => navigate(adminPath(`/evm/nodes?vds=${r.id}`));
    const columns = [
        { title: t('Node'), dataIndex: 'name', render: (v, r) => <Space direction="vertical" size={0}><a onClick={() => open(r)}>{v}</a><Text type="secondary" style={{ fontSize: 12 }}>#{r.id}</Text></Space> },
        { title: 'VDS', dataIndex: 'enabled', width: 90, render: (v, r) => (v ? <Tag color="green">{t(r.unit === 'thread' ? '线程' : '整核')}</Tag> : <Text type="secondary">{t('Disabled')}</Text>) },
        { title: 'CPU', key: 'cpu', render: (_, r) => (r.cpus ? <Tooltip title={r.model}>{t('{{n}} threads', { n: r.cpus })}{r.threads_per_core > 1 ? ` (×${r.threads_per_core})` : ''}</Tooltip> : <Text type="secondary">{t('Not reported')}</Text>) },
        { title: t('Host reserved'), dataIndex: 'reserved', width: 90 },
        { title: t('Held'), key: 'held', width: 120, render: (_, r) => `${r.held} · ${t('{{n}} VMs', { n: r.vds_vms })}` },
        { title: t('Available'), key: 'free', width: 140, render: (_, r) => t('{{c}} cores / {{th}} threads', { c: r.free_cores, th: r.free_threads }) },
        { title: t('Shared pool'), dataIndex: 'shared', width: 90, render: (v) => v ?? '-' },
        { title: 'Agent', dataIndex: 'agent_version', width: 100, render: (v) => v || '-' },
        { title: '', dataIndex: 'errors', width: 40, render: (e) => (e?.length ? <Tooltip title={e.join('；')}><WarningOutlined style={{ color: '#faad14' }} /></Tooltip> : null) },
    ];

    return (
        <div>
            <PageHeader title="VDS" extra={<Button icon={<ReloadOutlined />} onClick={load} loading={loading} />} />
            {data && !data.available ? <Empty description={t('Database not migrated')} /> : (
                <Table size="small" rowKey="id" loading={loading} dataSource={data?.nodes || []} columns={columns} pagination={false} scroll={{ x: 900 }} />
            )}
        </div>
    );
};

export default VdsNodes;
